
/* injects from baggage-loader */

'use strict';

const shared = angular.module('core.shared', []);

import validationTestDirective from './directives/validation-test/validation-test.directive';

import applicationController from './controllers/application.controller';

import constants from './services/constants';
import dialogFactory from './services/dialogs.factory';
import sessionFactory from './services/session.factory';
import storeFactory from './services/store.factory';
import fabricFactory from './services/fabric.factory';
import resolverProvider from './services/resolver.provider';

validationTestDirective(shared);

applicationController(shared);

constants(shared);
dialogFactory(shared);
storeFactory(shared);
sessionFactory(shared);
fabricFactory(shared);
resolverProvider(shared);

export default shared;



// WEBPACK FOOTER //
// ./src/app/core/core.module.js